import React from "react";
import "./style.scss";
import { Button } from "@material-ui/core";
function SessionMom() {
  return (
    <div className="sessionMom">
      <div className="col-md-10 sessionMom-detailspage">
        <div className="session-momHeading">
          <p className="display-heading">SESSION 3 MoM</p>
        </div>

        <table id="session">
          <tbody>
            <tr>
              <td className="session-question"><p>SESSION RATING BY STARTUP</p></td>
              <td className="session-answer"><p>4</p></td>
            </tr>
            <tr>
              <td className="session-question"><p>SESSION RATING BY MENTOR</p></td>
              <td className="session-answer"><p>4</p></td>
            </tr>
            <tr>
              <td className="session-question"><p>SESSION DURATION</p></td>
              <td className="session-answer"><p>2.5</p></td>
            </tr>

            <tr>
              <td className="session-question"><p>STARTUP SUMMARY</p></td>
              <td className="session-answer">
               <p>Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard Lorem
                Ipsum has been the industry's standard dummy text ever since the
                1500s, Lorem Ipsum has been the industry's standard dummy text
                ever since the 1500s, Lorem Ipsum has been the industry's
                standard dummy text ever since the 1500s, Lorem Ipsum has been
                the industry's standard dummy text ever since the 1500s,</p>
              </td>
            </tr>

            <tr>
              <td className="session-question"><p>MENTOR SUMMARY</p></td>
              <td className="session-answer"><p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.</p>
              </td>
            </tr>
            <tr>
              <td className="session-question"><p>DOCUMENT</p></td>
              <td className="session-answer">
                <Button
                  className="session-answerButton"
                  // style={{
                  //         backgroundColor: "#816aaf",
                  //         color: "#fff",
                  //         width: "200px",
                  //         fontFamily: "Montserrat",
                  //         fontSize: "16px",
                  //         fontWeight: 600,
                  //         lineHeight: "25px",
                  //         letterSpacing: "0.02857em",
                  //         textTransform: "uppercase",
                  //         marginTop: "20px",
                  //       }}
                  variant="outlined"
                >
                  VIEW DOCUMENT
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
        <Button
          className="session-backmom"
          // style={{
          //                   backgroundColor: "#3AC2D7",
          //                   color: "#fff",
          //                   width: "150px",
          //                   fontFamily: "Montserrat",
          //                   fontSize: "16px",
          //                   fontWeight: 600,
          //                   lineHeight: "25px",
          //                   letterSpacing: "0.02857em",
          //                   textTransform: "uppercase",
          //                   marginTop: "20px",
          //                 }}
          variant="outlined"
        >
          BACK
        </Button>
      </div>
    </div>
  );
}

export default SessionMom;
